export enum ChatsActionTypes {
  API_RESPONSE_SUCCESS = "@@chats/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@chats/API_RESPONSE_ERROR",

  GET_FAVOURITES = "@@chats/GET_FAVOURITES",
  GET_DIRECT_MESSAGES = "@@chats/GET_DIRECT_MESSAGES",
  GET_CHANNELS = "@@chats/GET_CHANNELS",

  GET_CHAT_ROOM_LIST = "@@chats/GET_CHAT_ROOM_LIST",
  LOAD_CUSTOMER_CONTENT = "@@chats/LOAD_CUSTOMER_CONTENT",
  GET_CONTENT_UNREAD_COUNT = "@@chats/GET_CONTENT_UNREAD_COUNT",
  GET_CONTENT_UNREAD_COUNT_ALL = "@@chats/GET_CONTENT_UNREAD_COUNT_ALL",

  ADD_CONTACTS = "@@chats/ADD_CONTACTS",
  CREATE_CHANNEL = "@@chats/CREATE_CHANNEL",
  CHANGE_SELECTED_CHAT = "@@chats/CHANGE_SELECTED_CHAT",
  CHANGE_SELECTED_CONTENT_TITLE = "@@chats/CHANGE_SELECTED_CONTENT_TITLE",
  CHANGE_SELECTED_CONTENT_TITLE_KEYID = "@@chats/CHANGE_SELECTED_CONTENT_TITLE_KEYID",
  REDUCE_CONTENT_TITLE_UNREAD = "@@chats/REDUCE_CONTENT_TITLE_UNREAD",
  GET_CHAT_USER_DETAILS = "@@chats/GET_CHAT_USER_DETAILS",
  GET_CHAT_USER_CONVERSATIONS = "@@chats/GET_CHAT_USER_CONVERSATIONS",
  GET_CHAT_USER_CONVERSATIONS_PREV = "@@chats/GET_CHAT_USER_CONVERSATIONS_PREV",
  GET_CHAT_USER_CONVERSATIONS_NEXT = "@@chats/GET_CHAT_USER_CONVERSATIONS_NEXT",
  TOGGLE_USER_DETAILS_TAB = "@@chats/TOGGLE_USER_DETAILS_TAB",
  DEL_USER_FROM_GROUP = "@@chats/DEL_USER_FROM_GROUP",
  GET_CHAT_USER_DETAILS_2S = "@@chats/GET_CHAT_USER_DETAILS_2S",
  GET_LAST_GROUP_CHAT_INFO_OF_MEMBER = "@@chats/GET_LAST_GROUP_CHAT_INFO_OF_MEMBER",
  ADD_USER_TO_GROUP = "@@chats/ADD_USER_TO_GROUP",

  // MESSAGE
  ON_SEND_MESSAGE = "@@chats/ON_SEND_MESSAGE",
  RECEIVE_MESSAGE = "@@chats/RECEIVE_MESSAGE",
  READ_MESSAGE = "@@chats/READ_MESSAGE",
  RECEIVE_MESSAGE_FROM_USER = "@@chats/RECEIVE_MESSAGE_FROM_USER",
  DELETE_MESSAGE = "@@chats/DELETE_MESSAGE",
  FORWARD_MESSAGE = "@@chats/FORWARD_MESSAGE",
  DELETE_USER_MESSAGES = "@@chats/DELETE_USER_MESSAGES",
  GET_CHANNEL_DETAILS = "@@chats/GET_CHANNEL_DETAILS",
  TOGGLE_FAVOURITE_CONTACT = "@@chats/TOGGLE_FAVOURITE_CONTACT",
  GET_ARCHIVE_CONTACT = "@@chats/GET_ARCHIVE_CONTACT",
  TOGGLE_ARCHIVE_CONTACT = "@@chats/TOGGLE_ARCHIVE_CONTACT",
  READ_CONVERSATION = "@@chats/READ_CONVERSATION",
  DELETE_IMAGE = "@@chats/DELETE_IMAGE",
  REPLY_IMAGE = "@@chats/REPLY_IMAGE",

  DELETE_MESSAGE_2S = "@@chat2s/DELETE_MESSAGE_2S",
  ADD_MESSAGE_2S = "@@chat2s/ADD_MESSAGE_2S",
  ADD_MESSAGE_2S_SUCCESS = "@@chat2s/ADD_MESSAGE_2S_SUCCESS",
  UPDATE_UNREAD_COUNT = "@@chat2s/UPDATE_UNREAD_COUNT",
  SET_GROUP_INVITE_CODE = "@@chat2s/SET_GROUP_INVITE_CODE",
  UPDATE_READ_PCNT_ON_MSG = "@@chat2s/UPDATE_READ_PCNT_ON_MSG",
  VIEW_MSG_MEMBER = "@@chat2s/VIEW_MSG_MEMBER",

  SET_PREVIEW_ATTACHFILE = "@@chat2s/SET_PREVIEW_ATTACHFILE",

  SET_TYPING_TEXT = "@@chat2s/SET_TYPING_TEXT",
  SET_TYPING_TAG = "@@chat2s/SET_TYPING_TAG",

  UPDATE_SENDER_INFO = "@@chat2s/UPDATE_SENDER_INFO",
  SET_RESP_EMOJI = "@@chat2s/SET_RESP_EMOJI",
  SET_RESP_EMOJI_WHMSG = "@@chat2s/SET_RESP_EMOJI_WHMSG",
  CHANGE_GROUP_FULL_NAME = "@@chat2s/CHANGE_GROUP_FULL_NAME",
  UNSEND_MESSAGE = "@@chat2s/UNSEND_MESSAGE",
  UPDATE_SENT_FLAG = "@@chat2s/UPDATE_SENT_FLAG",
  SET_PROFILE_ACTIVE_TAB = "@@chat2s/SET_PROFILE_ACTIVE_TAB",
  //FIND_FOR_FILTER_CHATROOM = "@@chat2s/FIND_FOR_FILTER_CHATROOM",
  FIND_FOR_FILTER_CHATROOM_SALE = "@@chat2s/FIND_FOR_FILTER_CHATROOM_SALE",
  FIND_FOR_FILTER_CHATROOM_CS = "@@chat2s/FIND_FOR_FILTER_CHATROOM_CS",
  FIND_FOR_FILTER_CHATROOM_PROVINCE = "@@chat2s/FIND_FOR_FILTER_CHATROOM_PROVINCE",

  UPDATE_IMAGE_ROTATE_INFO = "@@chat2s/UPDATE_IMAGE_ROTATE_INFO",


  ERP_GET_CUSTOMER_TASK = "@@chats/ERP_GET_CUSTOMER_TASK",
  ERP_GET_PREV_TOP_NO_VOLUME = "@@chats/ERP_GET_PREV_TOP_NO_VOLUME",
  ERP_CATE_SIZE_NOT_SALE_MORE_THAN_45 = "@@chats/ERP_CATE_SIZE_NOT_SALE_MORE_THAN_45",
  ERP_CATE_INTEREST_NOT_SALE = "@@chats/ERP_CATE_INTEREST_NOT_SALE",
  ERP_CATE_NOT_SALE_MORE_THAN_60 = "@@chats/ERP_CATE_NOT_SALE_MORE_THAN_60",

  SEARCH_CHAT = "@@chat/SEARCH_CHAT",
  QUICK_REPLY_LOAD_ALL = "@@chat/QUICK_REPLY_LOAD_ALL",
  QUICK_REPLY_SET_COUNT = "@@chat/QUICK_REPLY_SET_COUNT",
}

export type ADD_2S_TYPE = "I Add" | "New message" | "Bot";

export enum USER_DETAILS_TABS{
  Profile = 0,
  ERP = 1 ,
  SEARCH = 2,
}

export enum MessageTypes {
  NewMessage = 0
}

export interface ChatsState {
  favourites: Array<any>;
  chatRoomLists: Array<any>;
  directMessages: Array<any>;
  channels: Array<any>;
  selectedChat: string | number | null;
  selectedContentTitle: number | null;
  chatUserDetails: object;
  chatUserConversations: {};
  isOpenUserDetails: boolean;
  channelDetails: object;
  archiveContacts: Array<any>;
  typingText: Array<any>;
}
